import Vue from 'vue'
import Router from 'vue-router'
import Transfers from './components/transfers/Transfers'
import Trackers from './components/trackers/Trackers'
import Login from './components/Login'
import ErrorPage from './components/404'
import TransferDetail from './components/transfer-detail/TransferDetail'
import TrackerDetail from './components/tracker-detail/TrackerDetail'
import PasswordReset from './components/PasswordReset'
import PasswordResetConfirm from './components/PasswordResetConfirm'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Transfers',
      component: Transfers
    },
    {
      path: '/trackers',
      name: 'Trackers',
      component: Trackers
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/transfer/:transferId',
      name: 'Transfer',
      component: TransferDetail
    },
    {
      path: '/trackers/:trackerId',
      name: 'Tracker',
      component: TrackerDetail
    },
    {
      path: '/password/reset',
      name: 'PasswordReset',
      component: PasswordReset
    },
    {
      path: '/password/reset/confirm/:uid/:token',
      name: 'PasswordResetConfirm',
      component: PasswordResetConfirm,
      props: true
    },
    {
      path: '*',
      name: '404',
      component: ErrorPage
    }
  ]
})
